import { render, staticRenderFns } from "./two_factor.vue?vue&type=template&id=24b959d3&scoped=true&"
import script from "./two_factor.vue?vue&type=script&lang=js&"
export * from "./two_factor.vue?vue&type=script&lang=js&"
import style0 from "./two_factor.vue?vue&type=style&index=0&id=24b959d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b959d3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/franciscoriquelme/Documents/Elipse.ia/Proyectos/elipse-citas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24b959d3')) {
      api.createRecord('24b959d3', component.options)
    } else {
      api.reload('24b959d3', component.options)
    }
    module.hot.accept("./two_factor.vue?vue&type=template&id=24b959d3&scoped=true&", function () {
      api.rerender('24b959d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Perfil/two_factor.vue"
export default component.exports